import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FlashIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<g clipPath="url(#clip0_7660_187115)">
				<path
					d="M10.9956 21H9.99558L10.9956 14H7.49558C6.61558 14 7.16558 13.25 7.18558 13.22C8.47558 10.94 10.4156 7.54 13.0056 3H14.0056L13.0056 10H16.5156C16.9156 10 17.1356 10.19 16.9156 10.66C12.9656 17.55 10.9956 21 10.9956 21Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7660_187115">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

FlashIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FlashIcon;
